import React from 'react';

import ReactQueryProvider from '@/API/ReactQueryProvider';
import TopUpBanner from '@/pages/views/TopUpBanner';

const TopUpBannerWrapper = () => {
  return (
    <ReactQueryProvider>
      <TopUpBanner />
    </ReactQueryProvider>
  );
};

export default TopUpBannerWrapper;
